import React, { useState } from 'react';

import { Switch, Form, Divider, Select, InputNumber, Flex, Space, Col } from 'antd';

export interface IUserCarrier {
    carrierId: string;
    carrierName?: string;
    userId: string;
    isActive: boolean;
}

interface IUserCarriers {
    userCarriers: Array<IUserCarrier>;
    isViewOnly: boolean;
    onChange: (e: Array<IUserCarrier>) => void;
}

const UserCarriers = (props: IUserCarriers) => {
    const { userCarriers, isViewOnly, onChange } = props;

    return (
        <div>
            <Form.Item wrapperCol={{ span: 24 }}>
                <Divider style={{ marginBottom: 0 }} titlePlacement='left'>
                    Компании
                </Divider>
            </Form.Item>

            <Flex wrap gap='middle'>
                {userCarriers.map((c) => {
                    return (
                        <Form.Item
                            key={c.carrierId}
                            label={c.carrierName}
                            style={{ marginBottom: 0 }}
                            labelCol={{ span: 18 }}
                            wrapperCol={{ span: 6 }}
                        >
                            <Switch
                                size='small'
                                disabled={isViewOnly}
                                defaultChecked={c.isActive}
                                onChange={(value) => {
                                    const entities = [...userCarriers];

                                    const entity = entities.find((e) => e.carrierId === c.carrierId);

                                    if (entity) {
                                        entity.isActive = value;
                                        onChange([...entities]);
                                    }
                                }}
                            />
                        </Form.Item>
                    );
                })}
            </Flex>
        </div>
    );
};

export default UserCarriers;
